import React, { useState, useMemo, useEffect, useRef, ReactNode } from 'react';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import { Config } from '@/config';
import {
  errorModalTextRecoil,
  completeModalRecoil,
  modifyModalRecoil,
  eventDetailModalRecoil,
} from '@/atom/ModalAtom';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import styled from 'styled-components';
import LS from '@/styles/layoutStyled';
import CS from '@/styles/componentStyled';
import BS from '@/styles/btnStyled';
import IS from '@/styles/inputStyled';
import ModalType1 from '@/modal/ModalType1';
import { EventApi } from '@/sdk/EventApi';
import { eventDetailRecoil, eventDetailIdRecoil } from '@/atom/EventAtom';

interface EventDetailModalProps {
  modifyNum: number;
}

const EventDetailModal = ({ modifyNum }: EventDetailModalProps) => {
  const eventApi = new EventApi({ baseURL: Config.API_URL });
  const navigate = useNavigate();

  const setErrorModalText = useSetRecoilState(errorModalTextRecoil);
  const setCompleteModalState = useSetRecoilState(completeModalRecoil);
  const setEventDetailModalState = useSetRecoilState(eventDetailModalRecoil);
  const [eventDetailState, setEventDetailState] =
    useRecoilState(eventDetailRecoil);
  const [eventDetailIdState, setEventDetailIdState] =
    useRecoilState(eventDetailIdRecoil);

  const fetchEventDetail = async () => {
    try {
      const { data } = await eventApi.eventControllerGetEvent(
        Number(modifyNum),
        {
          headers: {
            Authorization: `Bearer ${String(sessionStorage.getItem('accessToken'))}`,
            'Content-Type': 'application/json',
          },
        },
      );
      setEventDetailState(data);
    } catch (err: any) {}
  };

  useEffect(() => {
    fetchEventDetail();
  }, []);

  return (
    <>
      <ModalType1 width={1000}>
        <div className="title-box flex aic jcsb">
          <h1>이벤트 상세 정보</h1>
          <button
            className="x-btn img-box"
            onClick={() => setEventDetailModalState(false)}
          >
            <img src="/img/ico_x_444.svg" alt="" />
          </button>
        </div>
        <div className="cnt-area flex fdc">
          <div className="cnt-wrap flex fdc">
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">이벤트 정보</h2>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th style={{ width: 160 }}>이벤트명</th>
                      <td>{eventDetailState?.name}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>이벤트 설명</th>
                      <td>{eventDetailState?.description}</td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">디바이스 정보</h2>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th style={{ width: 160 }}>디바이스명</th>
                      <td>{eventDetailState?.deviceName}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>디바이스 No</th>
                      <td>{eventDetailState?.deviceNumber}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>Dev EUI</th>
                      <td>{eventDetailState?.deviceDevEUI}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>시설명(시설번호)</th>
                      <td>{eventDetailState?.facilityName}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>설치 위치</th>
                      <td>{eventDetailState?.location}</td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">이벤트 상세 정보</h2>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th style={{ width: 160 }}>이벤트 발생 일시</th>
                      <td>{eventDetailState?.eventDate}</td>
                      <th style={{ width: 160 }}>이벤트 조건 필드</th>
                      <td>{eventDetailState?.eventConditionData}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>이벤트값</th>
                      <td>{eventDetailState?.eventValue}</td>
                      <th style={{ width: 160 }}>센서 측정 값</th>
                      <td>{eventDetailState?.sensorValue}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>
                        이벤트 조건 범위,
                        <br />
                        발생 횟수, 주기
                      </th>
                      <td colSpan={3}>
                        {eventDetailState?.eventRange},{' '}
                        {eventDetailState?.eventCount},{' '}
                        {eventDetailState?.eventCycle}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
            <div className="cnt-box flex fdc">
              <div className="cnt-title-box flex jcsb aie">
                <div className="left-box">
                  <h2 className="tm">SMS 수신 정보</h2>
                </div>
              </div>
              <CS.TableType2>
                <table>
                  <tbody>
                    <tr>
                      <th style={{ width: 160 }}>성명</th>
                      <td>{eventDetailState?.smsReceivedData[0].smsName}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>연락처</th>
                      <td>{eventDetailState?.smsReceivedData[0].smsPhone}</td>
                    </tr>
                    <tr>
                      <th style={{ width: 160 }}>수신시간</th>
                      <td>
                        {eventDetailState?.smsReceivedData[0].smsReceiveTime}
                      </td>
                    </tr>
                  </tbody>
                </table>
              </CS.TableType2>
            </div>
          </div>
          <div className="btn-wrap">
            <BS.Btn2Type3
              type="button"
              onClick={() => setEventDetailModalState(false)}
            >
              닫기
            </BS.Btn2Type3>
          </div>
        </div>
      </ModalType1>
    </>
  );
};

export default EventDetailModal;
